import { IconFillColor, IconWrapper, MapMarkerIcon } from '@dreryk/react-components';

export const VisitLocationIcon = (): JSX.Element => {
   return (
      <IconWrapper testId={'mapMarker'} fillColor={IconFillColor.BACKGROUND}>
         <MapMarkerIcon />
      </IconWrapper>
   );
};
